const data = [

    {
        id:1,
        img: 'https://sm.ign.com/t/ign_tr/news/w/wednesday-/wednesday-season-2-wont-be-headed-to-amazon-despite-rumors_j55s.1280.jpg',
        title: 'Project 1'
    },
    {
        id:2,
        img: 'https://cdn.pixabay.com/photo/2024/02/21/15/28/dahlia-8587940_1280.jpg',
        title: 'Project 2'
    },

    {
        id:3,
        img: 'https://media.istockphoto.com/id/153381618/tr/foto%C4%9Fraf/orange-dahlias-in-the-garden-among-other-flowers.jpg?s=612x612&w=is&k=20&c=mdJAKmffqeLDyPBSTReVC9VJlGTS2rDv0nEjTKMAino=',
        title: 'Project 3'

    },
    {
        id:4,
        img: 'https://cdn.pixabay.com/photo/2023/06/19/18/02/lavender-8075280_640.jpg',
        title: 'Project 4'
    },

    {
        id:5,
        img: 'https://cdn.pixabay.com/photo/2016/07/16/16/21/flowers-1522260_1280.jpg',
        title: 'Project 5'
    },
    {
        id:6,
        img: 'https://cdn.pixabay.com/photo/2014/02/27/16/10/flowers-276014_1280.jpg',
        title: 'Project 6'
    }


   

    
]

export default data